import Swiper from "swiper"
import { find } from "utils/dom"

export default function () {
	const Home = find("[js-page='home']")
	if (!Home) return

	console.log('Page home');

	 const swiper = new Swiper(".mySwiper", {
		slidesPerView:1,
		spaceBetween:0,

		navigation: {
			nextEl: ".swiper-button-next-home",
			prevEl: ".swiper-button-prev-home",
		},
    });

	 const swiperTime = new Swiper(".swiper-time", {
      slidesPerView: 'auto',
      spaceBetween: 16,
      freeMode: true,
    //   pagination: {
    //     el: ".swiper-pagination",
    //     clickable: true,
    //   },
    });
}
